import { __assign, __awaiter, __generator } from "tslib";
import * as React from 'react';
import s from './back-button.scss';
import { Box, Divider, TextButton, } from 'wix-style-react';
import { config } from '../../config';
import { composer } from '../../component-decorators/composer';
import { biLogger } from '../../bi';
import { useConfigContext } from '../../config-context';
import { ChevronLeftSmall, ChevronLeftLarge } from "wix-ui-icons-common";
export var BackButton = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var appId = _a.appId, t = _a.t, marketplaceStore = _a.marketplaceStore, skinColor = _a.skinColor, inSolutionPage = _a.inSolutionPage, hideText = _a.hideText;
    // tslint:disable-next-line: react-hooks-nesting
    var isMobile = useConfigContext().isMobile;
    function sendBiAndGoBack() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, biLogger.appMarketBackButtonClick({
                            appId: appId,
                            tag_type: (_a = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _a === void 0 ? void 0 : _a.path,
                            tag_name: (_b = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _b === void 0 ? void 0 : _b.referralTag,
                            market: config.originForBI,
                            msid: marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.metaSiteId,
                            location: hideText ? 'sticky-header' : 'page',
                        })];
                    case 1:
                        _c.sent();
                        config.goto(__assign(__assign({}, marketplaceStore.prevRoute), { referral: 'back_button' }));
                        return [2 /*return*/];
                }
            });
        });
    }
    var shouldShowDivider = !isMobile && inSolutionPage;
    var shouldAddMarginBottom = !shouldShowDivider || !isMobile;
    var marginUnderButton = isMobile ? '18px' : '24px';
    var text = hideText ? ' ' : t('marketplace.go-back.button');
    var buttonSize = hideText || isMobile ? 'medium' : 'small';
    return (React.createElement(React.Fragment, null,
        React.createElement(TextButton, { as: "button", skin: skinColor, dataHook: "back-button", onClick: sendBiAndGoBack, prefixIcon: isMobile ? React.createElement(ChevronLeftLarge, null) : React.createElement(ChevronLeftSmall, null), weight: "normal", size: buttonSize }, text),
        shouldShowDivider && (React.createElement(Divider, { className: s.divider, direction: "vertical" })),
        shouldAddMarginBottom && React.createElement(Box, { height: marginUnderButton })));
});
//# sourceMappingURL=back-button.js.map